<template>
    <a-modal :title="titlePrefix" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
             :confirm-loading="confirmLoading" @ok="onSubmit" @cancel="onClose" width="65%">
        <a-form layout="vertical" ref="ruleForm" :model="form" :rules="rules" @submit="onSubmit">
            <!--可编辑区域 start-->
            <div class="hidden">
                <a-form-item label="id" name="id">
                    <a-inputNumber style="width:100%" v-model:value="form.id"/>
                </a-form-item>
            </div>
            <a-row :gutter="[24,8]">
                <a-col :span="24">
                    <a-form-item label="发送方联系人姓名" name="senderContact">
                        <a-inputNumber style="width:100%" v-model:value="form.senderContact" placeholder="请输入发送方联系人姓名" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="发送方联系人电话" name="senderContactNumber">
                        <a-inputNumber style="width:100%" v-model:value="form.senderContactNumber" placeholder="请输入发送方联系人电话" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="接收方联系人姓名" name="receiveContact">
                        <a-inputNumber style="width:100%" v-model:value="form.receiveContact" placeholder="请输入接收方联系人姓名" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="接收方联系人电话" name="receiveContactNumber">
                        <a-inputNumber style="width:100%" v-model:value="form.receiveContactNumber" placeholder="请输入接收方联系人电话" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="已获投资金额" name="investAmount">
                        <a-inputNumber style="width:100%" v-model:value="form.investAmount" placeholder="请输入已获投资金额" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="拟投资金额" name="planInvestAmount">
                        <a-inputNumber style="width:100%" v-model:value="form.planInvestAmount" placeholder="请输入拟投资金额" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="对接类型（1企业联系投资人，2投资人联系企业, 3 线下,4企业联系投资机构的投资经理,5投资机构投资经理联系企业）" name="dockingType">
                        <a-inputNumber style="width:100%" v-model:value="form.dockingType" placeholder="请输入对接类型（1企业联系投资人，2投资人联系企业, 3 线下,4企业联系投资机构的投资经理,5投资机构投资经理联系企业）" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="审核状态：0 待审核，1 审核通过，2 审核未通过" name="auditStatus">
                        <a-inputNumber style="width:100%" v-model:value="form.auditStatus" placeholder="请输入审核状态：0 待审核，1 审核通过，2 审核未通过" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="接收状态 0 未读 1 已读" name="receiveState">
                        <a-inputNumber style="width:100%" v-model:value="form.receiveState" placeholder="请输入接收状态 0 未读 1 已读" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="批注" name="feedback">
                        <a-inputNumber style="width:100%" v-model:value="form.feedback" placeholder="请输入批注" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="对接备注" name="notes">
                        <a-inputNumber style="width:100%" v-model:value="form.notes" placeholder="请输入对接备注" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="线下业务备注" name="otherNotes">
                        <a-inputNumber style="width:100%" v-model:value="form.otherNotes" placeholder="请输入线下业务备注" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="备注" name="remark">
                        <a-inputNumber style="width:100%" v-model:value="form.remark" placeholder="请输入备注" />
                    </a-form-item>
                </a-col>
                <!--可编辑区域 end-->
            </a-row>
        </a-form>

    </a-modal>
</template>
<script>
import dataCheck from "@/utils/dataCheck";
import {formMixin} from "@/mixins";
import {financeCompanyInfo} from "@/api/finance";
import {innovation} from "@/config/variableConfig";

export default {
    name: "AddOrEditModal",
    components: {},

    mixins: [formMixin],
    data() {
        return {
            innovation,
            form: {
                id: null,
                companyCode: null,
                senderContact: null,
                senderContactNumber: null,
                receiveContact: null,
                receiveContactNumber: null,
                investAmount: null,
                planInvestAmount: null,
                dockingType: null,
                auditStatus: null,
                receiveState: null,
                feedback: null,
                notes: null,
                otherNotes: null,
                remark: null,

            },
            rules: {
                    id: [],
                    companyCode: [],
                    senderContact: [dataCheck.required({type:'number'})],
                    senderContactNumber: [dataCheck.required({type:'number'})],
                    receiveContact: [dataCheck.required({type:'number'})],
                    receiveContactNumber: [dataCheck.required({type:'number'})],
                    investAmount: [dataCheck.required({type:'number'})],
                    planInvestAmount: [dataCheck.required({type:'number'})],
                    dockingType: [dataCheck.required({type:'number'})],
                    auditStatus: [dataCheck.required({type:'number'})],
                    receiveState: [dataCheck.required({type:'number'})],
                    feedback: [dataCheck.required({type:'number'})],
                    notes: [dataCheck.required({type:'number'})],
                    otherNotes: [dataCheck.required({type:'number'})],
                    remark: [dataCheck.required({type:'number'})]
            },

            options: [],

        }
    },
    
    computed: {
            submitUrl() {
                if (this.form.id) {
                    return financeCompanyInfo.edit
                } else {
                    return financeCompanyInfo.add
                }
            },
            postMethod() {
                if (this.form.id) {
                    return 'put'
                } else {
                    return 'post'
                }
            }
        },
    mounted() {
    },
    methods: {
    },
}
</script>
<style scoped lang="less">
</style>
